import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@tSchaedlerYesco/Store/CustomReducers";
// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { css } from "styled-components";

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 1440, 1440, 1440],
    },
    globalStyle: {
        css: css`
            html body #txt2chat {
                position: fixed;
                top: 0;
                left: 0%;
                right: 0;
                bottom: 0;
                background-color: none;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 99999999;
                overflow-y: scroll;

                .container {
                    margin: auto 0px auto auto;
                    flex-direction: column !important;
                }
                #text2ChatBtn {
                    display: none;
                }
            }
        `,
    },
    button: {
        primary: {
            hoverStyle: {
                backgroundColor: "#0000FF",
            },
        },
    },
    focus: {
        width: "0",
    },
});
